



import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import sound from "../Catreingfolder/alaram copy.mp3";


const cateringOffers = [
  {
    id: 1,
    gole: "Buffet Lunch",
    description: "Enjoy unlimited buffet with 20% off!",
    couponCode: "BUFFET20",
    startDate: "2025-09-01",
    endDate: "2025-09-30",
    discountPercentage: 20,
    offerType: "buffet",
  },
  {
    id: 2,
    gole: "Wedding Package",
    description: "Flat 15% off on wedding catering bookings.",
    couponCode: "WED15",
    startDate: "2025-09-10",
    endDate: "2025-12-31",
    discountPercentage: 15,
    offerType: "wedding",
  },
  {
    id: 3,
    gole: "Birthday Special",
    description: "Book birthday catering & get 1kg cake free 🎂",
    couponCode: "BIRTHDAYFREE",
    startDate: "2025-09-05",
    endDate: "2025-11-30",
    discountPercentage: 10,
    offerType: "birthday",
  },
  {
    id: 4,
    gole: "Corporate Lunch",
    description: "Get 25% off on corporate lunch packages.",
    couponCode: "CORP25",
    startDate: "2025-09-01",
    endDate: "2025-10-31",
    discountPercentage: 25,
    offerType: "corporate",
  },
];
const Orders = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [vendorId, setVendorId] = useState(null);

  const scrollContainerRef = useRef(null);
  const [showTableDetails, setShowTableDetails] = useState({}); // ✅ track dine-in detail toggles

  const [showExpanded, setShowExpanded] = useState({}); // <-- added for Table Info toggle

  const [isPaused, setIsPaused] = useState(false);

  const toggleCard = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };
  const [expandedCard, setExpandedCard] = useState(null); // ✅ expand state
  const notificationSound = new Audio(sound);
  // ✅ Toggle handler for Table Info
  const handleToggleTableDetails = (uniqueId) => {
    setShowExpanded((prev) => ({
      ...prev,
      [uniqueId]: !prev[uniqueId], // toggle only this card
    }));
  };

  // ✅ Expand/collapse whole card
  // const handleOrderClick = (order) => {
  //   setExpandedOrder(
  //     expandedOrder && expandedOrder.orderId === order.orderId ? null : order
  //   );
  // };


  const handleOrderClick = (order) => {
    const id = order.orderId || order.cartId; // normalize ID
    console.log("Clicked order:", order); // ✅ debug

    if (expandedOrder && expandedOrder.id === id) {
      console.log("Collapsing order:", id);
      setExpandedOrder(null); // collapse
    } else {
      console.log("Expanding order:", id);
      setExpandedOrder({ ...order, id }); // expand
    }
  };



  const handleCheckboxChange = (orderId, itemIndex) => {
    const key = `${orderId}-${itemIndex}`;
    setCheckedItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };


  // ✅ Checkbox handler
  // const handleCheckboxChange = (uniqueId, idx) => {
  //   setCheckedItems((prev) => ({
  //     ...prev,
  //     [`${uniqueId}-${idx}`]: !prev[`${uniqueId}-${idx}`],
  //   }));
  // };
  // ✅ Toggle handler
  // const handleToggleTableDetails = (orderId) => {
  //   setShowTableDetails((prev) => ({
  //     ...prev,
  //     [orderId]: !prev[orderId],
  //   }));
  // };
  useEffect(() => {
    const storedVendorId = localStorage.getItem("vendorId");
    setVendorId(storedVendorId);
  }, []);

  // Fetch only PENDING orders
  // useEffect(() => {
  //   const fetchOrders = async () => {
  //     if (!vendorId) return; // Avoid running if vendorId is not yet set

  //     const token = localStorage.getItem("authToken"); // ✅ Retrieve token
  //     if (!token) {
  //       console.warn("No auth token found. Skipping fetch.");
  //       return;
  //     }

  //     try {
  //       const response = await axios.get(
  //         `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`, // ✅ Add token to request headers
  //           },
  //         }
  //       );

  //       const pendingOrders = response.data.filter(
  //         (order) => order.status === "CONFIRMED"
  //       );
  //       setOrders(pendingOrders);
  //     } catch (error) {
  //       console.error("Error fetching orders:", error.response?.data || error.message);
  //     }
  //   };

  //   fetchOrders();
  // }, [vendorId]);
  // Add a state to track accepted items


  const [acceptedItems, setAcceptedItems] = useState({});


  const handleAcceptOrderrs = async (e, itemId) => {
    e.stopPropagation();

    const status = "PROCESSING";
    const note = "sds"; // optional note
    const url = `https://backend.maamaas.com/food/api/cart/cartitem/status/${itemId}?status=${status}&note=${encodeURIComponent(note)}`;

    try {
      const response = await fetch(url, {
        method: "PUT", // or POST depending on your API
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      const data = await response.json();
      console.log("✅ Status updated:", data);

      // Optional: update local state so UI reflects change
      // e.g., remove item from list or update its status
    } catch (error) {
      console.error("❌ Failed to update status:", error);
    }
  };
  // Define fetchOrders outside useEffect so it can be called after accepting
  const fetchOrders = async () => {
    if (!vendorId) return;

    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      const vendorRes = await axios.get(
        `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const filteredVendorOrders = vendorRes.data.filter(
        (order) => !(order.orderType === "TABLE_DINE_IN" && order.status === "PENDING")
      );
      // 3️⃣ Separate pending and confirmed orders
      const pendingOrders = filteredVendorOrders.filter((order) => order.status === "PENDING");


      const confirmedOrdersFromVendor = vendorRes.data.filter(
        (order) =>
          Array.isArray(order.cartItems) &&
          order.cartItems.some((item) => item.orderStatus === "CONFIRMED")
      );

      // Fetch TABLE_DINE_IN orders all the data not founded in the catering of the paritcular data 
      const statuses = ["PENDING", "CONFIRMED"];
      const dineInPromises = statuses.map((status) =>
        axios.get(
          `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
      );

      const dineInResponses = await Promise.all(dineInPromises);
      const dineInOrders = dineInResponses.flatMap((res) => res.data || []);

      // Merge all results
      const allOrders = [...pendingOrders, ...confirmedOrdersFromVendor, ...dineInOrders];

      // Deduplicate
      const uniqueOrders = allOrders.filter(
        (order, index, self) =>
          index ===
          self.findIndex(
            (o) =>
              (o.cartId && o.cartId === order.cartId) ||
              (o.orderId && o.orderId === order.orderId)
          )
      );

      // 🔔 Check for new orders
      const previousOrdersIds = orders.map((o) => o.orderId || o.cartId);
      const newOrders = uniqueOrders.filter(
        (o) => !previousOrdersIds.includes(o.orderId || o.cartId)
      );

      if (newOrders.length > 0) {
        notificationSound.play().catch((e) => console.warn("Autoplay prevented:", e));
      }

      setOrders(uniqueOrders);
    } catch (error) {
      console.error("Error fetching orders:", error.response?.data || error.message);
    }
  };



  useEffect(() => {
    fetchOrders();
    const intervalId = setInterval(fetchOrders, 1000); // Refresh every 1 second
    return () => clearInterval(intervalId);
  }, [vendorId]);


  // 👈 watch vendorId changes

  // Auto-scroll logic
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;

    let interval;

    const startScrolling = () => {
      interval = setInterval(() => {
        if (!isHovered) {
          scrollContainer.scrollTop += 1;

          if (scrollContainer.scrollTop >= scrollContainer.scrollHeight / 2) {
            scrollContainer.scrollTop = 0;
          }
        }
      }, 20);
    };

    startScrolling();

    return () => clearInterval(interval);
  }, [isHovered]);

  const scrollRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollInterval;

    if (scrollContainer && !isPaused) {
      scrollInterval = setInterval(() => {
        if (
          scrollContainer.scrollTop + scrollContainer.clientHeight >=
          scrollContainer.scrollHeight
        ) {
          scrollContainer.scrollTop = 0;
        } else {
          scrollContainer.scrollTop += 1; // scroll speed
        }
      }, 50);
    }

    return () => clearInterval(scrollInterval);
  }, [isPaused]); // pause state control karega


  const getOfferColor = (type) => {
    switch (type) {
      case "buffet":
        return "#ff6f61";
      case "wedding":
        return "#6a5acd";
      case "birthday":
        return "#ffb347";
      case "corporate":
        return "#2e8b57";
      default:
        return "#333";
    }
  };



  // Accept button handler
  const handleAcceptOrderr = async (e, orderId) => {
    e.stopPropagation();

    const token = localStorage.getItem("authToken"); // ✅ Retrieve token
    if (!token) {
      alert("Authentication token is missing.");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CONFIRMED`,
        {
          status: "CONFIRMED", // send in body
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Add token to headers
          },
        }
      );

      console.log("Status updated:", response.data);

      // Update local UI
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
    } catch (error) {
      console.error("Failed to update order status:", error.response?.data || error.message);
    }
  };


  const handleDeclineOrder = async (e, orderId) => {
    e.stopPropagation();

    const token = localStorage.getItem("authToken"); // ✅ Retrieve token
    if (!token) {
      alert("Authentication token is missing.");
      return;
    }

    try {
      const response = await axios.put(
        `https://backend.maamaas.com/food/api/orders/edit-orders/${orderId}/CANCELLED`,
        {
          status: "CANCELLED", // send in body
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ Add token to headers
          },
        }
      );

      console.log("Status updated:", response.data);

      // Update local UI
      setOrders((prev) => prev.filter((order) => order.orderId !== orderId));
    } catch (error) {
      console.error("Failed to update order status:", error.response?.data || error.message);
    }
  };


  return (
    <div
      style={{
        position: "fixed",
        bottom: "62px",
        right: "16px",
        top: "40px",
        height: "560px",
        borderRadius: "8px",
        padding: "10px",
        marginTop: "40px",
      }}
      className="scroll-fixed-data mobilescroll"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        ref={scrollRef}
        style={{
          maxHeight: "570px",
          overflowY: "auto",
          paddingRight: "5px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          marginTop: "40px",
        }}
        className="hide-scrollbar"
      >
        {cateringOffers
          .filter((post) => new Date(post.endDate) >= new Date())
          .map((post, index) => (
            <div
              key={post.id}
              onClick={() => toggleCard(index)}
              className="card scroll-data-responsive"
              style={{
                width: "300px",
                marginBottom: "12px",
                background: getOfferColor(post.offerType),
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                cursor: "pointer",
                transition: "all 0.3s ease",
                padding: "15px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textAlign: "center",
                }}
              >
                <h4 style={{ color: "#fff", marginBottom: "10px" }}>
                  {post.gole} Offer 🎉
                </h4>
                <p style={{ color: "#f5f5f5", fontSize: "15px" }}>
                  {post.description}
                </p>
                <button
                  style={{
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    color: "#000",
                    border: "none",
                    padding: "6px 16px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Pay
                </button>
              </div>

              {expandedCard === index && (
                <div
                  style={{
                    marginTop: "10px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    padding: "10px",
                    borderRadius: "8px",
                    color: "#fff",
                  }}
                >
                  <p>
                    <strong>Coupon Code:</strong> {post.couponCode}
                  </p>
                  <p>
                    <strong>Valid From:</strong>{" "}
                    {new Date(post.startDate).toLocaleDateString()}
                  </p>
                  <p>
                    <strong>Valid Until:</strong>{" "}
                    {new Date(post.endDate).toLocaleDateString()}
                  </p>
                  <p>
                    <strong>Discount:</strong> {post.discountPercentage}%
                  </p>
                </div>
              )}
            </div>
          ))}
      </div>
    </div>

  );
};

export default Orders;

